/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
/* eslint-disable import/prefer-default-export */
import { ApiPrefixV1, ApiV1Base } from 'util/icwUtility';
import qs from 'qs';
import pick from 'lodash/pick';
import Request from '../../../api/request';
import { RequestInspectionJobAdapter, RequestInspectionInspectorWithJobAdapter } from '../adapters';

export const apiGetInspectors = async (params) => {
  let queryString = '';
  if (params) {
    queryString = qs.stringify(
      {
        pageNo: params.pageNo,
        pageSize: params.pageSize,
      },
      {
        encodeValuesOnly: false,
        indices: false,
      }
    );
  }
  return Request.call({
    url: `/micro/buyer/inspections/inspectors${queryString ? `?${queryString}` : ''}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiGetProductTags = async (params) => {
  const queryString = qs.stringify(
    {
      pageNo: params.current,
      pageSize: params.pageSize,
      ...pick(params, ['keywords']),
    },
    {
      encodeValuesOnly: false,
      indices: false,
    }
  );
  return Request.call({
    url: `/micro/products/tags${queryString ? `?${queryString}` : ''}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiGetInspectionJobs = async (params) => {
  // const { transformParams } = RequestInspectionJobAdapter(params);

  const queryString = qs.stringify(params, {
    encodeValuesOnly: false,
    indices: false,
  });
  return Request.call({
    url: `/micro/buyer/inspections${queryString ? `?${queryString}` : ''}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiGetInspectionInspectorWithJob = async (params) => {
  // const { transformParams } = RequestInspectionInspectorWithJobAdapter(params);
  const queryString = qs.stringify(params, {
    encodeValuesOnly: false,
    indices: false,
  });
  return Request.call({
    url: `/micro/buyer/inspections/inspectors/with-job${queryString ? `?${queryString}` : ''}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiGetInspectionDetail = async (inspectionId) => {
  return Request.call({
    url: `/micro/buyer/inspections/${inspectionId}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiGetInspectionReportById = async (inspectionId) => {
  return Request.call({
    url: `/micro/buyer/inspections/${inspectionId}/report`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiGet3rdServiceProviders = async (filters) => {
  return Request.call({
    url: `/micro/third-party/inspections/service-providers `,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    params: filters,
  });
};

export const apiGetInspectionDocuments = async (inspectionId, params) => {
  const queryString = qs.stringify(params, {
    encodeValuesOnly: false,
    indices: false,
  });
  return Request.call({
    url: `/micro/inspections/${inspectionId}/documents${queryString ? `?${queryString}` : ''}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiCreateAttachmentsByInspectionId = async (inspectionId, documentListIds) => {
  return Request.call({
    url: `/micro/inspections/${inspectionId}/documents`,
    method: 'POST',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    data: {
      documentListIds,
    },
  });
};

export const apiDeleteAttachment = async (inspectionId, documentId) => {
  return Request.call({
    url: `/micro/inspections/${inspectionId}/documents/${documentId}`,
    method: 'DELETE',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiUploadFile = async (formData) => {
  return Request.call({
    url: `/upload/multiple/file`,
    method: 'POST',
    data: formData,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiCreateDocument = async (data) => {
  return Request.call({
    url: `/micro/document-list`,
    method: 'POST',
    data: { ...data },
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiGetSampleSize = (params) => {
  const queryString = qs.stringify(params, {
    encodeValuesOnly: false,
    indices: false,
  });
  return Request.call({
    url: `/micro/sample-size${queryString ? `?${queryString}` : ''}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiGetInspectionReportDetail = (inspectionId) => {
  return Request.call({
    url: `/micro/buyer/inspections/${inspectionId}/report`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiInspectionAccept = (inspectionId) => {
  return Request.call({
    url: `/micro/buyer/inspections/${inspectionId}/accept`,
    method: 'POST',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiInspectionReject = (inspectionId, data) => {
  return Request.call({
    url: `/micro/buyer/inspections/${inspectionId}/reject`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiInspectionWaive = (inspectionId, data) => {
  return Request.call({
    url: `/micro/buyer/inspections/${inspectionId}/waive`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiInspectionReturn = (inspectionId, data) => {
  return Request.call({
    url: `/micro/buyer/inspections/${inspectionId}/return`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiValidateImportFile = async (formData) => {
  return Request.call({
    url: `/micro/inspections/import/validation`,
    method: 'POST',
    data: formData,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiImportInspection = async (formData) => {
  return Request.call({
    url: `/micro/inspections/import`,
    method: 'POST',
    data: formData,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiCreatePoItem = async (data) => {
  return Request.call({
    url: `/micro/products/bulk-create`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiGetInspectionProgress = async (jobId) => {
  return Request.call({
    url: `/micro/inspections/${jobId}/progress`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiTriggerGenerateReport = async (inspectionId) => {
  return Request.call({
    url: `/micro/inspections/${inspectionId}/generate-report-background`,
    method: 'POST',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiExportInspection = async (params) => {
  const { content, startDate, endDate } = params;
  const exports = {
    jobList: 'iqc/exports',
    reportDetails: 'job-report-result/exports',
  };
  return Request.call({
    url: `/micro/inspections/${exports[content]}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    params: {
      startDate,
      endDate,
    },
  });
};
